import { themes } from "@seneca/senekit";

import { ThemeSetPreference } from "seneca-common/features/user/state/models/UserPreferences";

type GetThemeArgs = {
  isPlurallApp: boolean;
  isOnParentPlatform: boolean;
  userHasSubscription: boolean;
  isDarkMode: boolean;
  preferredThemeSet?: ThemeSetPreference | null;
};

export function getTheme(args: GetThemeArgs) {
  const themeSet = getThemeSet(args);

  if (args.isDarkMode) {
    return themeSet.dark;
  }

  return themeSet.light;
}

function getThemeSet({
  isPlurallApp,
  userHasSubscription,
  isOnParentPlatform,
  preferredThemeSet
}: GetThemeArgs) {
  if (isPlurallApp) {
    return themes.plurall;
  }

  if (userHasSubscription) {
    if (isOnParentPlatform && !preferredThemeSet) {
      return themes.free;
    }

    if (!preferredThemeSet || preferredThemeSet === ThemeSetPreference.PURPLE) {
      return themes.premium;
    }
  }

  return themes.free;
}
